import React from "react";
import { Form } from "semantic-ui-react";
import styled from "styled-components";

const StyledInput = styled(Form.Input)`
  text-align: center;
`;

interface EditableColumnProps {
  content: string | number;
  isTableEditable: boolean;
  onChange: (content: string) => void;
}

const EditableColumn: React.FC<EditableColumnProps> = ({
  content,
  isTableEditable,
  onChange,
}) => {
  return (
    <React.Fragment>
      {isTableEditable ? (
        <StyledInput
          fluid
          size="mini"
          type={typeof content}
          placeholder={content}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onChange(e.currentTarget.value)
          }
        />
      ) : (
        content
      )}
    </React.Fragment>
  );
};

export default EditableColumn;
